import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSidebarWideLeftArrow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSidebarWideLeftArrow"><Path d="M15.25 9.5L12.75 12L15.25 14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 4.5H21.5V19.5H2.5V4.5Z" stroke="currentColor"/><Path d="M7.5 4.5V12V19.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconSidebarWideLeftArrow;
